import {
  getJti,
  isHotelProperty,
  isNormal,
  isSiDaProperty,
  isWeddingDressProperty,
  isWeddingRingJewelryProperty
} from '@merchant-backend/util'
import {
  goToMerchantCenter,
  hasStaffAuth,
  isNewMerchantOnlineShop,
  isNotExamined,
  isRoleService,
  isSanDaMember,
  isSanDaTeam,
  isSiYiMember,
  isSiYiTeam,
  isSuperAdmin
} from '@util'
import systemApi from '@api/system'
import React from 'react'
import Menu from './Menu'
import SettingStyle from './Setting/style.module.less'
import { OperateMenuItem } from '@merchant-backend/common-components'
import style from '@components/NewMenu/style.module.less'
import { HLJ_MERCHANT_MY_COUNT } from '@merchant-backend/common-components/src/Head/constant'

export const MENU_TYPE = {
  ITEM_GROUP: 'itemGroup'
}

export const MENU_HOME = 1 // 首页
export const MENU_SHOP = 2 // 店铺
export const MENU_HOTEL = 3 // 酒店
export const MENU_MEMBER = 4 // 个人
export const MENU_TEAM = 5 // 团队
export const MENU_MANAGE = 6 // 经营
export const MENU_MARKETING = 7 // 营销
export const MENU_POPULARIZE = 8 // 推广
export const MENU_DATA = 9 // 数据
export const MENU_SHOP_HOME = 10 // 店铺主页
export const MENU_CONTENT_SETTING_SHOP = 11 // 店铺->内容配置
export const MENU_CREATE_CENTER = 12 // 店铺->创作中心
export const MENU_HOTEL_HOME = 13 // 酒店主页
export const MENU_HOTEL_DECORATION = 92 // 酒店店铺装修
export const MENU_HOTEL_MANAGE = 14 // 酒店管理
export const MENU_MEMBER_HOME = 15 // 个人主页
export const MENU_CONTENT_SETTING_MEMBER = 16 // 个人->内容配置
export const MENU_TEAM_HOME = 17 // 团队主页
export const MENU_CONTENT_SETTING_TEAM = 18 // 团队->内容配置
export const MENU_CUSTOMER = 19 // 客资列表
export const MENU_ORDER_MANAGE = 20 // 订单管理
export const MENU_INCOME_MANAGE = 21 // 收入管理
export const MENU_APPRAISE_MANAGE = 22 // 评价管理
export const MENU_EXPERIENCE = 23 // 体验店
export const MENU_SCHEDULE_MANAGE = 24 // 档期管理
export const MENU_SCHEDULE = 25 // 档期
export const MENU_TEAM_MANAGE = 26 // 团队管理
export const MENU_POPULARIZE_CENTER = 27 // 推广中心
export const MENU_SHOP_DATA = 28 // 店铺数据
export const MENU_CONTENT_DATA = 29 // 内容数据
export const MENU_SHOP_ANALYSIS = 30 // 装修分析
export const MENU_DECORATION_SHOP = 31 // 店铺->店铺主页->主页装修
export const MENU_LITEAPP = 32 // 小程序
export const MENU_WEI_SHOP_HOME = 33 // 店铺->店铺主页->微官网
export const MENU_BRAND_SETTING = 34 // 品牌页配置
export const MENU_MEAL_SHOP = 35 // 店铺->内容配置->套餐
export const MENU_CASE_SHOP = 36 // 店铺->内容配置->案例
export const MENU_CUSTOM_SERVICE = 89 // 店铺->内容配置->婚礼服务
export const MENU_PHOTAGRAPHER = 37 // 店铺->内容配置->摄影师
export const MENU_VR_SHOP = 38 // 店铺->内容配置->VR全景
export const MENU_PLANNER = 39 // 店铺->内容配置->策划师
export const MENU_SINGLE = 40 // 店铺->内容配置->单品
export const MENU_DYNAMIC_SHOP = 41 // 店铺->内容配置->动态
export const MENU_STYLE = 88 // 店铺->内容配置->款式
export const MENU_CREATE_HOME = 42 // 店铺->创作中心->创作首页
export const MENU_MY_CREATIVE = 43 // 店铺->创作中心->我的创作
export const MENU_COVER_SETTING = 44 // 封面设置
export const MENU_UNIQUE_INFO = 45 // 特色信息
export const MENU_SPECIAL_YOUHUI = 46 // 专享优惠
export const MENU_THEME_TPL = 47 // 主题模板
export const MENU_WEI_SHOP_HOTEL = 48 // 酒店->酒店主页->微官网
export const MENU_ALBUM = 49 // 相册管理
export const MENU_SITE = 50 // 场地管理
export const MENU_MENU_MANAGE = 51 // 菜单管理
export const MENU_MEAL_HOTEL = 52 // 酒店->酒店管理->套餐
export const MENU_VR_HOTEL = 53 // 酒店->酒店管理->VR全景
export const MENU_DYNAMIC_HOTEL = 54 // 酒店->酒店管理->动态
export const MENU_ONE_STOP = 55 // 一站式服务
export const MENU_DECORATION_MEMBER = 56 // 个人->个人主页->主页装修
export const MENU_MEAL_MEMBER = 57 // 个人->内容配置->套餐
export const MENU_CASE_MEMBER = 58 // 个人->内容配置->案例
export const MENU_DYNAMIC_MEMBER = 59 // 个人->内容配置->动态
export const MENU_DECORATION_TEAM = 60 // 团队->团队主页->主页装修
export const MENU_MEAL_TEAM = 61 // 团队->内容配置->套餐
export const MENU_CASE_TEAM = 62 // 团队->内容配置->案例
export const MENU_DYNAMIC_TEAM = 63 // 团队->内容配置->动态
export const MENU_EXPERIENCE_COOP = 64 // 体验店合作
export const MENU_EXPERIENCE_RECO = 65 // 体验店推荐
export const MENU_LIST_MODE = 66 // 列表模式
export const MENU_CALENDAR_MODE = 67 // 日历模式
export const MENU_TEAM_MEMBER = 68 // 团队成员
export const MENU_TEAM_SCHEDULE = 69 // 团队档期
export const MENU_TEAM_SETTING = 70 // 团队设置
export const MENU_POPULARIZE_CENTER_HOME = 71 // 推广->推广中心->首页
export const MENU_CREATIVE_CENTER = 72 // 推广->推广中心->创意中心
export const MENU_ZHIYOUTOU = 73 // 智优投
export const MENU_ZHITUIBAO = 74 // 智推宝
export const MENU_JUKEBAO = 75 // 聚客宝
export const MENU_SHOP_SERVICE = 76 // 店铺服务
export const MENU_HOTEL_SERVICE = 77 // 酒店服务
export const MENU_MEMBER_SERVICE = 78 // 个人服务
export const MENU_TEAM_SERVICE = 79 // 团队服务
export const MENU_SHOP_RECORD = 80 // 店铺服务-购买记录
export const MENU_SHOP_COUPONS = 81 // 店铺服务-我的卡券

export const MENU_HOTEL_RECORD = 82 // 酒店服务-购买记录
export const MENU_HOTEL_COUPONS = 83 // 酒店服务-我的卡券
export const MENU_MEMBER_RECORD = 84 // 个人服务-购买记录
export const MENU_MEMBER_COUPONS = 85 // 个人服务-我的卡券
export const MENU_TEAM_RECORD = 86 // 团队服务-购买记录
export const MENU_TEAM_COUPONS = 87 // 团队服务-我的卡券

export const NOTIFICATION_MANAGE = 91 // 经营-通知管理

export const MENU_TEAM_MY_ACCOUNT = 90 // 我的（团队）-我的账户

export const MENU_MEMBER_MY_ACCOUNT = 100 // 我的（genre）-我的账户

export const MENU_TEAM_CONFIG = 93 // 团队配置
export const MENU_TEAM_CONFIG_TEAM_MEMBER = 95 // 团队配置-团队成员
export const MENU_TEAM_CONFIG_SERVICE_DESCRIPTION = 96 // 团队配置-服务说明
export const MENU_TEAM_CONFIG_PERSONALIZED_SERVICE = 97 // 团队服务-个性化服务

export const MENU_SERVICE_CONFIG = 94 // 服务配置
export const MENU_SERVICE_CONFIG_SERVICE_DESCRIPTION = 98 // 服务配置 服务说明
export const MENU_SERVICE_CONFIG_PERSONALIZED_SERVICE = 99 // 服务配置 个性化服务

export const getMenu = async () => {
  const { success, data = false } = await systemApi.checkJkb()
  const jkbVisible = success && data

  return [
    {
      id: MENU_HOME,
      title: '首页',
      path: '/localMerchant/home',
      icon: 'icon-shouye1'
    },
    isHotelProperty() && !isRoleService()
      ? {
          id: MENU_HOTEL,
          title: '酒店',
          icon: 'icon-dianpu1',
          sub: [
            {
              id: MENU_HOTEL_HOME,
              title: '酒店主页',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_HOTEL_DECORATION,
                  title: '店铺装修',
                  path: '/localMerchant/decoration'
                },
                {
                  id: MENU_COVER_SETTING,
                  title: '封面设置',
                  path: '/localMerchant/coverSetting'
                },
                {
                  id: MENU_UNIQUE_INFO,
                  title: '特色信息',
                  path: '/localMerchant/uniqueInfo'
                },
                {
                  id: MENU_SPECIAL_YOUHUI,
                  title: '专享优惠',
                  path: '/localMerchant/exclusiveOffers'
                },
                {
                  id: MENU_THEME_TPL,
                  title: '主题模板',
                  path: '/localMerchant/themeChose'
                },
                {
                  id: MENU_WEI_SHOP_HOTEL,
                  title: '微官网',
                  path: '/localMerchant/weiShopSetting'
                }
              ]
            },
            {
              id: MENU_HOTEL_MANAGE,
              title: '酒店管理',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_ALBUM,
                  title: '相册',
                  path: '/localMerchant/albumManage'
                },
                {
                  id: MENU_SITE,
                  title: '场地',
                  path: '/localMerchant/siteManage'
                },
                {
                  id: MENU_MENU_MANAGE,
                  title: '菜单',
                  path: '/localMerchant/menuManage'
                },
                {
                  id: MENU_MEAL_HOTEL,
                  title: '套餐',
                  path: '/localMerchant/mealManage'
                },
                {
                  id: MENU_VR_HOTEL,
                  title: 'VR全景',
                  path: '/localMerchant/vr'
                },
                {
                  id: MENU_DYNAMIC_HOTEL,
                  title: '动态',
                  path: '/localMerchant/creation'
                },
                {
                  id: MENU_ONE_STOP,
                  title: '一站式服务',
                  path: '/localMerchant/ossm'
                }
              ]
            },
            {
              id: MENU_HOTEL_SERVICE,
              title: '酒店服务',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_HOTEL_RECORD,
                  title: '购买记录',
                  path: '/localMerchant/purchaseHistory'
                },
                {
                  id: MENU_HOTEL_COUPONS,
                  title: '我的卡券',
                  path: '/localMerchant/myCoupon'
                }
              ]
            }
          ]
        }
      : null,
    isSanDaMember()
      ? {
          id: MENU_MEMBER,
          title: '个人',
          icon: 'icon-dianpu1',
          sub: [
            {
              id: MENU_MEMBER_HOME,
              title: '个人主页',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_DECORATION_MEMBER,
                  title: '主页装修',
                  path: '/localMerchant/decoration'
                }
              ]
            },
            {
              id: MENU_CONTENT_SETTING_MEMBER,
              title: '内容配置',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_MEAL_MEMBER,
                  title: '套餐',
                  path: '/localMerchant/setMeal'
                },
                {
                  id: MENU_CASE_MEMBER,
                  title: '作品',
                  path: '/localMerchant/case'
                },
                {
                  id: MENU_DYNAMIC_MEMBER,
                  title: '动态',
                  path: '/localMerchant/dynamic'
                }
              ]
            },
            {
              id: MENU_MEMBER_SERVICE,
              title: '个人服务',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_MEMBER_RECORD,
                  title: '购买记录',
                  path: '/localMerchant/purchaseHistory'
                },
                {
                  id: MENU_MEMBER_COUPONS,
                  title: '我的卡券',
                  path: '/localMerchant/myCoupon'
                }
              ]
            }
          ]
        }
      : null,
    isSiYiMember()
      ? {
          id: MENU_MEMBER,
          title: '店铺',
          icon: 'icon-dianpu1',
          sub: [
            {
              id: MENU_MEMBER_HOME,
              title: '店铺主页',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_DECORATION_MEMBER,
                  title: '主页装修',
                  path: '/localMerchant/decoration'
                }
              ]
            },
            {
              id: MENU_CONTENT_SETTING_MEMBER,
              title: '内容配置',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_MEAL_MEMBER,
                  title: '套餐',
                  path: '/localMerchant/setMeal'
                },
                {
                  id: MENU_CASE_MEMBER,
                  title: '作品',
                  path: '/localMerchant/case'
                },
                {
                  id: MENU_DYNAMIC_MEMBER,
                  title: '动态',
                  path: '/localMerchant/dynamic'
                }
              ]
            },
            {
              id: MENU_SERVICE_CONFIG,
              title: '服务配置',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_SERVICE_CONFIG_SERVICE_DESCRIPTION,
                  title: '服务说明',
                  path: '/localMerchant/serviceConfig'
                },
                {
                  id: MENU_SERVICE_CONFIG_PERSONALIZED_SERVICE,
                  title: '个性化服务',
                  path: '/localMerchant/upgradeService'
                }
              ]
            }
          ]
        }
      : null,
    isSanDaTeam()
      ? {
          id: MENU_TEAM,
          title: '团队',
          icon: 'icon-dianpu1',
          sub: [
            {
              id: MENU_TEAM_HOME,
              title: '团队主页',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_DECORATION_TEAM,
                  title: '主页装修',
                  path: '/localMerchant/decoration'
                }
              ]
            },
            {
              id: MENU_CONTENT_SETTING_TEAM,
              title: '内容配置',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_MEAL_TEAM,
                  title: '套餐',
                  path: '/localMerchant/setMeal'
                },
                {
                  id: MENU_CASE_TEAM,
                  title: '作品',
                  path: '/localMerchant/case'
                },
                {
                  id: MENU_DYNAMIC_TEAM,
                  title: '动态',
                  path: '/localMerchant/dynamic'
                }
              ]
            },
            {
              id: MENU_TEAM_SERVICE,
              title: '团队服务',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_TEAM_RECORD,
                  title: '购买记录',
                  path: '/localMerchant/purchaseHistory'
                },
                {
                  id: MENU_TEAM_COUPONS,
                  title: '我的卡券',
                  path: '/localMerchant/myCoupon'
                }
              ]
            }
          ]
        }
      : null,
    isSiYiTeam()
      ? {
          id: MENU_TEAM,
          title: '店铺',
          icon: 'icon-dianpu1',
          sub: [
            {
              id: MENU_TEAM_HOME,
              title: '店铺主页',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_DECORATION_TEAM,
                  title: '主页装修',
                  path: '/localMerchant/decoration'
                }
              ]
            },
            {
              id: MENU_CONTENT_SETTING_TEAM,
              title: '内容配置',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_MEAL_TEAM,
                  title: '套餐',
                  path: '/localMerchant/setMeal'
                },
                {
                  id: MENU_CASE_TEAM,
                  title: '作品',
                  path: '/localMerchant/case'
                },
                {
                  id: MENU_DYNAMIC_TEAM,
                  title: '动态',
                  path: '/localMerchant/dynamic'
                }
              ]
            },
            {
              id: MENU_TEAM_CONFIG,
              title: '团队配置',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_TEAM_CONFIG_TEAM_MEMBER,
                  title: '团队成员',
                  path: '/localMerchant/siYiTeamGroupMember'
                },
                {
                  id: MENU_TEAM_CONFIG_SERVICE_DESCRIPTION,
                  title: '服务说明',
                  path: '/localMerchant/serviceConfig'
                },
                {
                  id: MENU_TEAM_CONFIG_PERSONALIZED_SERVICE,
                  title: '个性化服务',
                  path: '/localMerchant/upgradeService'
                }
              ]
            }
          ]
        }
      : null,
    !isSiDaProperty() && !isHotelProperty() && !isRoleService()
      ? {
          id: MENU_SHOP,
          title: '店铺',
          icon: 'icon-dianpu1',
          sub: [
            {
              id: MENU_SHOP_HOME,
              title: '店铺主页',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_DECORATION_SHOP,
                  title: '主页装修',
                  path: '/localMerchant/decoration'
                },
                {
                  id: MENU_LITEAPP,
                  title: '小程序',
                  path: '/localMerchant/liteApp'
                },
                {
                  id: MENU_WEI_SHOP_HOME,
                  title: '微官网',
                  path: '/localMerchant/weiShopSetting'
                },
                {
                  id: MENU_BRAND_SETTING,
                  title: '品牌页配置',
                  path: '/localMerchant/brand'
                }
              ]
            },
            {
              id: MENU_CONTENT_SETTING_SHOP,
              title: '内容配置',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_MEAL_SHOP,
                  title: isWeddingRingJewelryProperty() ? '商品' : '套餐',
                  path: '/localMerchant/setMeal'
                },
                {
                  id: MENU_SINGLE,
                  title: '单品',
                  path: '/localMerchant/singleProduct'
                },
                {
                  id: MENU_CASE_SHOP,
                  title: '案例',
                  path: '/localMerchant/case'
                },
                {
                  id: MENU_CUSTOM_SERVICE,
                  title: '婚礼服务',
                  path: '/localMerchant/customService'
                },
                {
                  id: MENU_DYNAMIC_SHOP,
                  title: '动态',
                  path: '/localMerchant/dynamic'
                },
                {
                  id: MENU_PHOTAGRAPHER,
                  title: '摄影师',
                  path: '/localMerchant/photography'
                },
                {
                  id: MENU_VR_SHOP,
                  title: 'VR全景',
                  path: '/localMerchant/vr'
                },
                {
                  id: MENU_PLANNER,
                  title: '策划师',
                  path: '/localMerchant/planner'
                },
                {
                  id: MENU_STYLE,
                  title: '款式',
                  path: '/localMerchant/addressStyle'
                }
              ]
            },
            {
              id: MENU_CREATE_CENTER,
              title: '创作中心',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_CREATE_HOME,
                  title: '创作首页',
                  path: '/localMerchant/contentCenter'
                },
                {
                  id: MENU_MY_CREATIVE,
                  title: '我的创作',
                  path: '/localMerchant/creation'
                }
              ]
            },
            {
              id: MENU_SHOP_SERVICE,
              title: '店铺服务',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_SHOP_RECORD,
                  title: '购买记录',
                  path: '/localMerchant/purchaseHistory'
                },
                {
                  id: MENU_SHOP_COUPONS,
                  title: '我的卡券',
                  path: '/localMerchant/myCoupon'
                }
              ]
            }
          ]
        }
      : null,
    {
      id: MENU_MANAGE,
      title: '经营',
      icon: 'icon-jingying1',
      render: (item, node) => {
        const { icon, title } = item
        return (
          <OperateMenuItem
            key={item.id}
            item={
              <div className={style.menu} key={item.id}>
                {icon && <i className={`iconfont ${icon}`} />}
                <span>{title}</span>
              </div>
            }
            node={node}
          />
        )
      },
      sub: [
        {
          id: MENU_CUSTOMER,
          title: '客资管理',
          path: '/localMerchant/customerManage'
        },
        {
          id: MENU_ORDER_MANAGE,
          title: '订单管理',
          path: '/localMerchant/orderManage_new'
        },
        isSuperAdmin()
          ? {
              id: NOTIFICATION_MANAGE,
              title: '通知管理',
              path: '/localMerchant/notificationManage'
            }
          : null,
        !isRoleService()
          ? {
              id: MENU_INCOME_MANAGE,
              title: '收入管理',
              path: '/localMerchant/incomeManage'
            }
          : null,
        {
          id: MENU_APPRAISE_MANAGE,
          title: '评价管理',
          path: '/localMerchant/appraise'
        },
        {
          id: MENU_EXPERIENCE,
          title: '体验店',
          type: MENU_TYPE.ITEM_GROUP,
          sub: [
            !isRoleService()
              ? {
                  id: MENU_EXPERIENCE_COOP,
                  title: '体验店合作',
                  path: '/localMerchant/experienceShopManage'
                }
              : null,
            {
              id: MENU_EXPERIENCE_RECO,
              title: '体验店推荐',
              path: '/localMerchant/experienceShop'
            }
          ]
        },
        {
          id: MENU_SCHEDULE,
          title: '档期',
          path: '/localMerchant/scheduleTool'
        },
        !isRoleService()
          ? {
              id: MENU_SCHEDULE_MANAGE,
              title: '档期管理',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_LIST_MODE,
                  title: '列表模式',
                  path: '/localMerchant/listMode'
                },
                {
                  id: MENU_CALENDAR_MODE,
                  title: '日历模式',
                  path: '/localMerchant/calendarMode'
                }
              ]
            }
          : null,
        !isSiYiTeam()
          ? {
              id: MENU_TEAM_MANAGE,
              title: '团队管理',
              type: MENU_TYPE.ITEM_GROUP,
              sub: [
                {
                  id: MENU_TEAM_MEMBER,
                  title: '团队成员',
                  path: '/localMerchant/groupMember'
                },
                {
                  id: MENU_TEAM_SCHEDULE,
                  title: '团队档期',
                  path: '/localMerchant/groupSchedule'
                },
                {
                  id: MENU_TEAM_SETTING,
                  title: '团队设置',
                  path: '/localMerchant/groupSetting'
                }
              ]
            }
          : null
      ]
    },
    !isRoleService()
      ? {
          id: MENU_MARKETING,
          title: '营销',
          path: '/localMerchant/marketingCenter',
          icon: 'icon-yingxiao1'
        }
      : null,
    !isRoleService()
      ? {
          id: MENU_POPULARIZE,
          title: '推广',
          icon: 'icon-tuiguang1',
          path: '/localMerchant/promoteMarketingPage',
          render: (item, node) => {
            return isNewMerchantOnlineShop() ? (
              <Menu.Item key={item.id} item={item} />
            ) : (
              node
            )
          },
          sub: [
            {
              id: MENU_POPULARIZE_CENTER_HOME,
              title: '推广首页',
              path: '/localMerchant/popularization'
            },
            {
              id: MENU_ZHIYOUTOU,
              title: '智优投',
              path: '/localMerchant/zhiGuangTong'
            },
            {
              id: MENU_ZHITUIBAO,
              title: '智推宝',
              path: '/localMerchant/zhiTuiBao'
            },
            {
              id: MENU_CREATIVE_CENTER,
              title: '创意中心',
              path: '/localMerchant/creativeCenter'
            },
            jkbVisible
              ? {
                  id: MENU_JUKEBAO,
                  title: '聚客宝',
                  path: '/localMerchant/jukeTreasure'
                }
              : {}
          ]
        }
      : null,
    !isRoleService()
      ? {
          id: MENU_DATA,
          title: '数据',
          icon: 'icon-shuju1',
          path: '/localMerchant/dataMarketingPage',
          render: (item, node) => {
            return isNewMerchantOnlineShop() || isNormal() ? (
              <Menu.Item key={item.id} item={item} />
            ) : (
              node
            )
          },
          sub: [
            {
              id: MENU_SHOP_DATA,
              title: '店铺数据',
              path: '/localMerchant/shopData'
            },
            {
              id: MENU_CONTENT_DATA,
              title: '内容数据',
              path: '/localMerchant/contentData'
            },
            {
              id: MENU_SHOP_ANALYSIS,
              title: '装修分析',
              path: '/localMerchant/decorationAnalysis'
            }
          ]
        }
      : null,
    isSiYiTeam()
      ? {
          id: MENU_TEAM_SERVICE,
          title: '我的',
          icon: 'icon-shuju1',
          sub: [
            {
              id: MENU_TEAM_RECORD,
              title: '购买记录',
              path: '/localMerchant/purchaseHistory'
            },
            {
              id: MENU_TEAM_COUPONS,
              title: '我的卡券',
              path: '/localMerchant/myCoupon'
            },
            {
              id: MENU_TEAM_MY_ACCOUNT,
              title: '我的账号',
              absolutePath: HLJ_MERCHANT_MY_COUNT + getJti()
            }
          ]
        }
      : null,
    isSiYiMember()
      ? {
          id: MENU_MEMBER_SERVICE,
          title: '我的',
          icon: 'icon-shuju1',
          sub: [
            {
              id: MENU_MEMBER_RECORD,
              title: '购买记录',
              path: '/localMerchant/purchaseHistory'
            },
            {
              id: MENU_MEMBER_COUPONS,
              title: '我的卡券',
              path: '/localMerchant/myCoupon'
            },
            {
              id: MENU_MEMBER_MY_ACCOUNT,
              title: '我的账号',
              absolutePath: HLJ_MERCHANT_MY_COUNT + getJti()
            }
          ]
        }
      : null
  ]
}

/**
 * 底部设置二级菜单
 */
export const getSettingMenu = () => {
  return [
    {
      id: 999,
      title: '设置',
      icon: 'icon-shezhi',
      sub: [
        !isRoleService()
          ? {
              id: 1,
              title: '基本信息',
              path: '/localMerchant/editStore',
              render: (item, node) => {
                if (isNotExamined()) {
                  return null
                }

                return node
              }
            }
          : null,
        !isRoleService()
          ? {
              id: 2,
              title: '店铺证照',
              path: '/localMerchant/realnameAuthentication',
              render: (item, node) => {
                if (isNotExamined()) {
                  return null
                }

                return node
              }
            }
          : null,
        // {
        //   id: 3,
        //   title: '绑定微信号',
        //   path: '/localMerchant/sellerService'
        // },
        !isRoleService() && !isHotelProperty()
          ? {
              id: 4,
              title: '结算账户',
              path: '/localMerchant/settlementAccount'
            }
          : null,
        !isRoleService()
          ? {
              id: 5,
              title: '品牌代理认证',
              path: '/localMerchant/certification',
              render: (item, node) => {
                if (isWeddingDressProperty()) {
                  return node
                }

                return null
              }
            }
          : null,
        !isSiDaProperty() && hasStaffAuth()
          ? {
              id: 6,
              title: '员工管理',
              path: '/localMerchant/staff',
              render: (item, node, { isOpenHcy }) => {
                // 开通海草云跳商家中心员工管理
                if (!__DEV__ && isOpenHcy) {
                  return (
                    <div
                      onClick={() => {
                        goToMerchantCenter(4)
                      }}
                      className={SettingStyle.menu}
                    >
                      <span>{item.title}</span>
                    </div>
                  )
                }

                return node
              }
            }
          : null
      ]
    }
  ]
}

// 这个对象里的 key （真实pathname）为了对应菜单，会被替换为指定菜单的 pathname
export const replacePaths = {
  nameCardManage: 'marketingCenter',
  liveManage: 'marketingCenter',
  SkyEyeSystem: 'marketingCenter',
  activityRegister: 'marketingCenter',
  coupons: 'marketingCenter'
}
